import React from "react";
import { auth } from "@/lib/api";
import Layout, { PageHeader, Surface } from "@/components/Layout";

export default function Settings() {
  const u = auth.user() || {};
  return (
    <Layout>
      <div className="p-4 sm:p-6 lg:p-10" data-testid="settings-page">
        <PageHeader title="Settings" subtitle="Profile and platform configuration." />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <Surface className="p-6">
            <div className="font-display text-xl tracking-tight font-medium mb-4">Profile</div>
            <div className="space-y-3 text-sm">
              <Row k="Name" v={u.name} />
              <Row k="Email" v={u.email} />
              <Row k="Role" v={u.role} />
            </div>
          </Surface>

          <Surface className="p-6">
            <div className="font-display text-xl tracking-tight font-medium mb-4">Platform</div>
            <div className="space-y-3 text-sm">
              <Row k="Issuer" v="Blonix Issuer Network" />
              <Row k="Mode" v={<span className="font-mono text-xs">{process.env.NODE_ENV}</span>} />
              <Row k="Region" v="Global" />
            </div>
          </Surface>
        </div>
      </div>
    </Layout>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-center justify-between border-b border-zinc-100 pb-2 last:border-0 last:pb-0">
      <span className="text-zinc-500">{k}</span>
      <span className="font-medium">{v || "—"}</span>
    </div>
  );
}
